import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "Come ricevo il materiale dopo l'acquisto?",
    a: "Subito dopo il pagamento accedi all'area riservata con la stessa email usata in cassa. Lì trovi il workbook completo in PDF e tutti i modelli: tuoi per sempre, consultabili quando vuoi.",
  },
  {
    q: "Quanto tempo mi richiede il percorso?",
    a: "Circa 20-30 minuti al giorno per 7 giorni. È pensato per imprenditrici impegnate: ogni giornata si conclude con un'azione concreta, non con teoria da studiare.",
  },
  {
    q: "Non ho ancora collaboratori: funziona lo stesso?",
    a: "Sì. Il metodo ti aiuta prima a organizzare le procedure, così quando arriverà il primo collaboratore (dipendente, assistente virtuale o freelance) saprai esattamente cosa affidargli e come.",
  },
  {
    q: "Serve esperienza di gestione aziendale?",
    a: "No. Ogni strumento è un modello pronto da compilare: checklist, schede di assegnazione e sistemi di misurazione ti guidano passo dopo passo.",
  },
  {
    q: "Ho bisogno di aiuto: come vi contatto?",
    a: "Scrivici a lamiaprimaoradiliberta@outlook.it oppure su WhatsApp al +39 389 626 5156: rispondiamo personalmente a ogni richiesta, di solito entro un giorno lavorativo.",
  },
];

const Item = ({ q, a, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-ink/10">
      <button
        onClick={() => setOpen(!open)}
        data-testid={`faq-question-${index}`}
        className="flex w-full items-center justify-between gap-6 py-6 text-left"
      >
        <span className="font-serif text-lg text-ink sm:text-xl">{q}</span>
        <motion.span
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ duration: 0.3 }}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ink/15 text-terracotta"
        >
          <Plus className="h-4 w-4" />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <p data-testid={`faq-answer-${index}`} className="max-w-2xl pb-6 text-sm leading-relaxed text-taupe sm:text-base">{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const Faq = () => (
  <section id="faq" className="bg-sand/60 py-24 sm:py-32">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal className="text-center">
        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-terracotta">Domande frequenti</span>
        <h2 className="mt-4 font-serif text-2xl tracking-tight text-ink sm:text-3xl lg:text-4xl">
          Tutto chiaro, <em className="italic text-terracotta">prima di iniziare</em>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-12">
          {FAQS.map((f, i) => (
            <Item key={i} q={f.q} a={f.a} index={i} />
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
